<mat-toolbar class="toolbar-default fixed-top">
  <div class="d-flex flex-row align-items-center justify-content-start w-100">
    <div class="logo-wrap">
      <a (click)="index();" style="" matTooltip="Splits - Estimez vous" matTooltipShowDelay="1000" class="hand-pointer"><img src="/assets/img/app/logo_main.png"  alt="Splits" class="logo"></a>
    </div>
  </div>
</mat-toolbar>
